import useApi from "..";

const usePostApi = () => {
    const { request, isLoading } = useApi(); 
  
    const createPost = (payload) => request('/social-media/post', 'POST', payload);
    const updatePost = (payload, postId) => request(`/social-media/post/${postId}`, 'PUT', payload);
    const reportPost = (payload, postId) => request(`/social-media/${postId}/report`, 'POST', payload);
    const sharePost = (payload, postId) => request(`/social-media/post/${postId}/share`, 'POST', payload);
    const addPostComment = (payload, postId) => request(`/social-media/post/${postId}/comment`, 'POST', payload);
    const reportComment = (payload, commentId) => request(`/social-media/comment/${commentId}/report`, 'POST', payload);
    const getPostsAndPolls = (limit, offset) => request(`/social-media/feed?limit=${limit}&offset=${offset}`, 'GET', null);
    const searchPostByHashtag = (query) => request(`/social-media/post/search?tag=${query}`, 'GET', null);
    const getPostById = (postId) => request(`/social-media/post/${postId}`, 'GET', null);
    const deletePost = (postId) => request(`/social-media/post/${postId}`, 'DELETE', null);
    const deleteComment = (commentId) => request(`/social-media/comment/${commentId}`, 'DELETE', null);
    const likeDislikePost = (postId) => request(`/social-media/post/${postId}/like-dislike`, 'PATCH', null);

    const getPollById = (pollId) => request(`/social-media/poll/${pollId}`, 'GET', null);
    const addPollComment = (payload, pollId) => request(`/social-media/poll/${pollId}/comment`, 'POST', payload);
    const deletePollComment = (pollId) => request(`/social-media/comment/${pollId}`, 'DELETE', null);
    const createPoll = (payload) => request('/social-media/poll', 'POST', payload);
    const updatePoll = (payload, pollId) => request(`/social-media/poll/${pollId}`, 'PUT', payload);
    const voteOnPoll = (pollId, optionId) => request(`/social-media/poll/${pollId}/option/${optionId}`, 'POST', null);
    const deletePoll = (pollId) => request(`/social-media/poll/${pollId}`, 'DELETE', null);
    const reportPoll = (payload, pollId) => request(`/social-media/${pollId}/report`, 'POST', payload);
    const likeDislikePoll = (pollId) => request(`/social-media/poll/${pollId}/like-dislike`, 'PATCH', null);

    return { 
        isLoading,
        createPost, 
        updatePost, 
        reportPost, 
        sharePost, 
        addPostComment, 
        reportComment, 
        getPostsAndPolls, 
        searchPostByHashtag, 
        getPostById, 
        deletePost, 
        deleteComment, 
        likeDislikePost,
        getPollById,
        addPollComment,
        deletePollComment,
        createPoll,
        updatePoll,
        voteOnPoll,
        reportPoll,
        likeDislikePoll,
        deletePoll
    };
};

export default usePostApi;
